import { iUploadeImagesList } from './imageUpload';

/* 游戏 */
export interface iSelectGameSearch {
  id: number;
  name: string;
}

/* 查询 */
export interface iSelectGame {
  name?: string;
  source?: string;
  page_size?: Number;
  category_type?: number;
  ygx_game_id?: number | undefined;
  isb?: number;
  act_free?: number;
}
/* 游戏分类 */
export interface iSelectGameType {
  name?: string;
  id?: number;
  sort?: number;
  version?: number;
}
/* 热门游戏分类 */
export interface iSelectHotGameType {
  name?: string;
  id?: number;
  sort?: number;
  version?: number;
  endpoint: number;
}
export interface iGameModel {
  id: number;
  name: string;
  category_id: number;
  account_num: number;
  remark: string;
  gid: string;
  path: string;
  file_id: number;
  act_free: number;
  main_img: string;
  category_name: string;
  game_media: iUploadeImagesList[];
  sbl?: any;
  account_mode: number;
  steam_gid: string;
  archive_path: string;
  conn_tips: string;
  process_name: string;
  process_watch_min: number | null;
  times_limit: number;
}
/* 虚拟键盘 */
export interface iVirtualKeyboard {
  name: string;
  page: number;
  page_size: number;
}

/* 账号查询 */
export interface iSelectGameAccount {
  status: number;
  username: string;
  game_id: number;
}

/* 账号信息 */
export interface iGameAccount {
  id: number;
  username?: string;
  pwd?: string;
  status?: number;
  game_id?: number;
  editor?: boolean;
  offline_cache_name?: string;
  offline_cache_md5?: string;
  archive_path?: string;
}
export interface iGameTimesLimit {
  id: number;
  times_limit: number;
}
export enum eAccountType {
  ONLINE = 1,
  OFFLINE = 2,
}

export enum eActFreeType {
  NOFREE = 0,
  FREE = 1,
}
